import axios from "../axios-auth";

export const checkInReportService = {
    getCheckInReportList
};

function getCheckInReportList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.wayAssignNo) {
        params["wayAssignNo"] = searchParams.wayAssignNo;
    }

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }

    if (searchParams.userName) {
        params["userName"] = searchParams.userName;
    }

    if (searchParams.customerShopId) {
        params["customerShopId"] = searchParams.customerShopId;
    }

    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.cashierId) {
        params["cashierId"] = searchParams.cashierId;
    }

    return axios.get("/auth/check-in-report", { params });
}